import { render } from "./PersonaContentView.vue?vue&type=template&id=2a8f3d93&scoped=true"
import script from "./PersonaContentView.vue?vue&type=script&lang=js"
export * from "./PersonaContentView.vue?vue&type=script&lang=js"

import "./PersonaContentView.vue?vue&type=style&index=0&id=2a8f3d93&scoped=true&lang=css"

import exportComponent from "/home/PersonaExplorer/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a8f3d93"]])

export default __exports__